export enum ALIGNMENT {
  left = 'left',
  right = 'right',
}
